import axios, { AxiosInstance } from "axios";

export const make88iClientApi = (
  path: string,
  apiKey = process.env.REACT_APP_88I_API_KEY
): AxiosInstance => {
  return axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/${path}`,
    headers: {
      "x-api-key": apiKey,
    },
  });
};
